import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
  {/*<path
          d="M 40.1 70 L 9 12.2 L 9 70 L 0 70 L 0 0 L 12.6 0 L 43.5 58.2 L 43.5 0 L 52.5 0 L 52.5 70 L 40.1 70 Z M 70.5 70 L 70.5 0 L 112 0 L 112 8.2 L 80 8.2 L 80 29.6 L 106.7 29.6 L 106.7 37.4 L 80 37.4 L 80 70 L 70.5 70 Z"
          fill="currentColor"
        />*/}
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
